// PBL төсөл (сурагч /study/pbl/:id, эцэг эх ?s=<хүүхэд>): дөрвөн үе шат (хүрэх үр дүн, үйл ажиллагаа), баг, бүтээл, үр дүн.
import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Input, Spin, message } from "antd";
import { FiArrowLeft, FiCheckCircle, FiChevronRight, FiFolder } from "react-icons/fi";
import { instance } from "utils/axios";
import { get, base } from "./shared";

const PHASE_COLOR = ["#1f9ea5", "#5c1090", "#c98f00", "#d94d1f"];
const ACTIVITY = { lesson: "Хичээл", assignment: "Даалгавар", assessment: "Шалгалт", trip: "Аялал" };
const errText = (e) => e?.response?.data?.error || e?.response?.data?.value || "Алдаа гарлаа";
const openFile = (url) => instance({ method: "get", url, responseType: "blob", silent: true }).then((r) => window.open(URL.createObjectURL(r.data), "_blank")).catch(() => message.error("Файл нээгдсэнгүй"));

// Сурлагын хуудсанд: миний төслүүд (байхгүй бол юу ч харуулахгүй)
export function PblCards({ who }) {
  const [list, setList] = useState(null);
  useEffect(() => { get(`${base(who)}/pbl`).then(setList).catch(() => setList([])); }, [who]);
  if (!list?.length) return null;
  const s = who !== "me" ? `?s=${who}` : "";
  return (
    <section className="flex flex-col gap-2">
      <h2 className="m-0 text-base font-bold">Төсөл</h2>
      <div className="grid gap-2 grid-cols-1 sm:grid-cols-2">
        {list.map((p) => (
          <Link key={p.id} to={`/study/pbl/${p.id}${s}`} className="tj-card !rounded-xl px-4 py-3 flex items-center gap-3 !text-[#1c1c1c] hover:bg-[#faf7ff]">
            <FiFolder className="text-primary shrink-0" size={22} />
            <span className="flex-1 min-w-0">
              <span className="block text-sm font-bold truncate">{p.name}</span>
              <span className="block text-xs text-gray-500 truncate">{p.courses} · {p.statusName}</span>
            </span>
            <FiChevronRight className="text-primary shrink-0" />
          </Link>
        ))}
      </div>
    </section>
  );
}

function ExitTicket({ who, pid, s, canAct, onSaved }) {
  const [text, setText] = useState(s.answer || "");
  const [busy, setBusy] = useState(false);
  const send = () => {
    setBusy(true);
    instance({ method: "post", url: `${base(who)}/pbl/${pid}/sessions/${s.id}/answer`, data: { answer: text }, silent: true })
      .then((r) => { message.success("Илгээлээ"); onSaved(r.data); }).catch((e) => message.error(errText(e))).then(() => setBusy(false));
  };
  return (
    <div className="rounded-xl bg-[#e2f4f5] p-3 flex flex-col gap-2">
      <span className="text-[11px] font-bold uppercase tracking-wide text-[#1f7f85]">Exit Ticket</span>
      <span className="text-sm font-semibold">{s.exitQuestion}</span>
      {canAct ? (
        <>
          <Input.TextArea value={text} onChange={(e) => setText(e.target.value)} autoSize={{ minRows: 2, maxRows: 6 }} maxLength={3000} placeholder="Хариултаа бичнэ үү…" />
          <button type="button" className="pchip pchip-on !h-9 self-end" disabled={busy || text.trim().length < 2} onClick={send}>{s.answer ? "Шинэчлэх" : "Илгээх"}</button>
        </>
      ) : <span className="text-sm whitespace-pre-wrap">{s.answer || <span className="text-gray-400">Хариулаагүй</span>}</span>}
    </div>
  );
}

function AddWork({ who, pid, sessions, onAdded }) {
  const [f, setF] = useState({ title: "", url: "", sessionId: "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const send = () => {
    const fd = new FormData();
    Object.entries(f).forEach(([k, v]) => v && fd.append(k, v));
    if (file) fd.append("file", file);
    setBusy(true);
    instance({ method: "post", url: `${base(who)}/pbl/${pid}/works`, data: fd, silent: true })
      .then((r) => { message.success("Бүтээл нэмэгдлээ"); setF({ title: "", url: "", sessionId: "" }); setFile(null); onAdded(r.data); })
      .catch((e) => message.error(errText(e))).then(() => setBusy(false));
  };
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <Input value={f.title} onChange={(e) => setF((x) => ({ ...x, title: e.target.value }))} placeholder="Нэр (Прототип 1…)" style={{ width: 180 }} />
      {sessions.length > 0 && <select value={f.sessionId} onChange={(e) => setF((x) => ({ ...x, sessionId: e.target.value }))} className="border border-[#e5d8f5] rounded-lg h-8 px-2 text-sm bg-white" aria-label="Цаг">
        <option value="">Цаг (заавал биш)</option>
        {sessions.map((s) => <option key={s.id} value={s.id}>{s.no}. {s.title}</option>)}
      </select>}
      <Input value={f.url} onChange={(e) => setF((x) => ({ ...x, url: e.target.value }))} placeholder="https://… холбоос" style={{ width: 200 }} />
      <label className="pchip pchip-off !h-8 cursor-pointer">{file ? `📎 ${file.name.slice(0, 20)}` : "Файл сонгох"}<input type="file" hidden onChange={(e) => setFile(e.target.files[0] || null)} /></label>
      <button type="button" className="pchip pchip-on !h-8" disabled={busy || (!file && !f.url)} onClick={send}>Нэмэх</button>
    </div>
  );
}

export default function StudyPbl() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const who = params.get("s") || "me";
  const [d, setD] = useState(null);
  useEffect(() => { get(`${base(who)}/pbl/${id}`).then(setD).catch(() => setD({ error: true })); }, [who, id]);
  if (!d) return <div className="flex justify-center py-16"><Spin /></div>;
  if (d.error) return <div className="pt-8 max-w-3xl mx-auto text-sm text-gray-500">Төсөл олдсонгүй.</div>;
  const p = d.project;
  const open = d.sessions.filter((s) => s.open && s.exitQuestion);
  const fileUrl = (kind, fid) => `${base(who)}/pbl/${p.id}/file/${kind}/${fid}`;
  const sessionTitle = Object.fromEntries(d.sessions.map((s) => [s.id, `${s.no}. ${s.title}`]));

  return (
    <div className="pt-4 md:pt-8 pb-8 max-w-3xl mx-auto w-full flex flex-col gap-4">
      <Link to={who === "me" ? "/study" : `/child?c=${who}`} className="self-start text-sm text-primary flex items-center gap-1"><FiArrowLeft /> Сурлага</Link>
      <div className="flex flex-col gap-1">
        <span className="text-xs font-bold uppercase tracking-wide text-gray-500">Төсөл · {p.statusName}</span>
        <h1 className="m-0 text-[26px] md:text-[32px] font-extrabold text-primary leading-tight">{p.name}</h1>
        <p className="m-0 text-sm">{p.goal}</p>
      </div>

      {d.team && (
        <section className="tj-card p-4 flex flex-col gap-2">
          <div className="flex items-center justify-between gap-2"><h2 className="m-0 text-base font-bold">Миний баг: {d.team.name}</h2>
            <span className="flex gap-1">{d.team.gates.map((g) => <span key={g.gate} className={`text-[11px] font-bold rounded-full px-2 py-0.5 ${g.passed ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-500"}`}>Checkpoint {g.gate}{g.passed ? " ✓" : ""}</span>)}</span>
          </div>
          <span className="text-sm text-gray-600">{d.team.members.map((m) => m.name).join(", ")}</span>
          {d.team.problemStatement && <p className="m-0 text-sm italic">“{d.team.problemStatement}”</p>}
        </section>
      )}

      {open.length > 0 && (
        <section className="flex flex-col gap-2.5">
          <h2 className="m-0 text-base font-bold">Exit Ticket</h2>
          {[...open].reverse().map((s) => (
            <div key={s.id} className="flex flex-col gap-1">
              <span className="text-xs text-gray-500">{s.no}-р цаг · {s.title}</span>
              <ExitTicket who={who} pid={p.id} s={s} canAct={d.canAct} onSaved={(r) => setD((x) => ({ ...x, sessions: x.sessions.map((y) => (y.id === s.id ? { ...y, ...r } : y)) }))} />
            </div>
          ))}
        </section>
      )}

      <section className="flex flex-col gap-2.5">
        <h2 className="m-0 text-base font-bold">Төслийн үе шат</h2>
        <div className="grid gap-2.5 grid-cols-1 sm:grid-cols-2">
          {d.plan.map((x, i) => (
            <div key={x.phase} className="tj-card !rounded-xl p-3.5 flex flex-col gap-1.5">
              <span className="text-sm font-bold" style={{ color: PHASE_COLOR[i] }}>{i + 1}. {x.name}</span>
              {x.goal && <p className="m-0 text-sm whitespace-pre-wrap">{x.goal}</p>}
              {x.activities.map((a) => (
                <span key={a.id} className="text-xs text-gray-600">{ACTIVITY[a.kind]}: <b className="font-semibold">{a.title}</b>{a.date ? ` · ${a.date.slice(5).replace("-", ".")}` : ""}{a.kind === "trip" ? ` · ${a.hours} цаг` : ""}</span>
              ))}
            </div>
          ))}
        </div>
      </section>

      {d.sessions.length > 0 && <section className="tj-card p-4 flex flex-col gap-3">
        <h2 className="m-0 text-base font-bold">Цагийн төлөвлөгөө</h2>
        {d.phases.map((name, i) => (
          <div key={i} className="flex flex-col gap-1.5">
            <span className="text-xs font-bold" style={{ color: PHASE_COLOR[i] }}>{i + 1} · {name}</span>
            {d.sessions.filter((s) => s.phase === i + 1).map((s) => (
              <div key={s.id} className="flex items-start gap-2 text-sm">
                <span className="w-5 text-gray-400 tabular-nums shrink-0">{s.no}</span>
                <span className="flex-1">
                  <span className="font-semibold">{s.title}</span>{s.product ? <span className="text-gray-500"> → {s.product}</span> : null}
                  {s.materials.map((m) => (
                    <span key={m.id} className="block text-xs">{m.kind === "link" ? <a href={m.url} target="_blank" rel="noreferrer">🔗 {m.title}</a> : <button type="button" className="bg-transparent border-0 p-0 text-primary cursor-pointer" onClick={() => openFile(fileUrl("m", m.id))}>📎 {m.title}</button>}</span>
                  ))}
                </span>
                {s.doneAt ? <FiCheckCircle className="text-emerald-600 shrink-0 mt-0.5" /> : s.answer ? <FiCheckCircle className="text-gray-300 shrink-0 mt-0.5" /> : null}
              </div>
            ))}
          </div>
        ))}
      </section>}

      <section className="tj-card p-4 flex flex-col gap-3">
        <h2 className="m-0 text-base font-bold">Бүтээл</h2>
        {!d.works.length && <span className="text-sm text-gray-500">Бүтээл ороогүй байна.</span>}
        {d.works.map((w) => (
          <div key={w.id} className="text-sm flex flex-wrap gap-x-2">
            {w.fileName ? <button type="button" className="bg-transparent border-0 p-0 text-primary cursor-pointer" onClick={() => openFile(fileUrl("w", w.id))}>📎 {w.title}</button> : <a href={w.url} target="_blank" rel="noreferrer">🔗 {w.title}</a>}
            {w.sessionId && <span className="text-gray-400 text-xs self-center">{sessionTitle[w.sessionId]}</span>}
          </div>
        ))}
        {d.canAct && <AddWork who={who} pid={p.id} sessions={d.sessions} onAdded={(w) => setD((x) => ({ ...x, works: [w, ...x.works] }))} />}
      </section>

      <section className="tj-card p-4 flex flex-col gap-2">
        <h2 className="m-0 text-base font-bold">Суралцахуйн үр дүн</h2>
        {d.outcomes.map((o) => (
          <div key={o.id} className="flex items-start gap-3 text-sm">
            <span className="flex-1"><span className="text-xs text-gray-500 block">{o.course}</span>{o.text}</span>
            <span className={`shrink-0 text-xs font-bold rounded-lg px-2 py-1 ${o.result?.status === "achieved" ? "bg-emerald-50 text-emerald-700" : o.result ? "bg-amber-50 text-amber-800" : "bg-gray-100 text-gray-500"}`}>
              {o.result?.status === "achieved" ? "Хүрсэн" : o.result ? "Хараахан биш" : "Үнэлээгүй"}
            </span>
          </div>
        ))}
        {p.result && <p className="m-0 mt-2 text-sm"><b>Багшийн дүгнэлт:</b> {p.result}</p>}
      </section>
    </div>
  );
}
